// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"11f8460c","92":"630feedf","164":"3c775524","254":"13c3dcc0","265":"c7aefd4e","283":"b88af367","521":"378fa2f1","554":"867dafd6","656":"dfb8839c","673":"979ec13a","808":"f0910144","863":"78dd84d6","966":"f8c21732"}[chunkId] + ".chunk.js";
};